import "core-js/stable";
import {Loader} from 'google-maps';

class LocationMap {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError("[LocationMap.js] Invalid element");
    }

    this.element = element;

    setTimeout(() => {
      this.init();
    }, 10);
  }

  async loadLib() {
    const loader = new Loader(this.key, {});
    return await loader.load();
  }

  init() {
    if (typeof window.wordpress_globals.google_maps_api_key === "undefined") {
      throw new Error("[LocationMap.js] Google Maps key not defined");
    }

    if (typeof this.element.dataset.lat === "undefined" || typeof this.element.dataset.lng === "undefined") {
      throw new Error("[LocationMap.js] Malformed or undefined lat/lng values");
    }

    this.key = window.wordpress_globals.google_maps_api_key ?? undefined;

    this.initMap();
  }

  initMap() {
    this.loadLib().then((google) => {
      const lat = parseFloat(this.element.dataset.lat);
      const lng = parseFloat(this.element.dataset.lng);

      this.map = new google.maps.Map(this.element, {
        center: {
          lat: lat,
          lng: lng
        },
        zoom: 14,
        disableDefaultUI: true
      });

      this.map.setOptions({
        styles: [
          {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e9e9e9"
              },
              {
                "lightness": 17
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#f5f5f5"
              },
              {
                "lightness": 20
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#ffffff"
              },
              {
                "lightness": 17
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#ffffff"
              },
              {
                "lightness": 29
              },
              {
                "weight": 0.2
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#ffffff"
              },
              {
                "lightness": 18
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#ffffff"
              },
              {
                "lightness": 16
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#f5f5f5"
              },
              {
                "lightness": 21
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#dedede"
              },
              {
                "lightness": 21
              }
            ]
          },
          {
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "visibility": "on"
              },
              {
                "color": "#ffffff"
              },
              {
                "lightness": 16
              }
            ]
          },
          {
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "saturation": 36
              },
              {
                "color": "#333333"
              },
              {
                "lightness": 40
              }
            ]
          },
          {
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#f2f2f2"
              },
              {
                "lightness": 19
              }
            ]
          },
          {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#fefefe"
              },
              {
                "lightness": 20
              }
            ]
          },
          {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#fefefe"
              },
              {
                "lightness": 17
              },
              {
                "weight": 1.2
              }
            ]
          }
        ]
      });

      this.marker = new google.maps.Marker({
        position: {lat: lat, lng: lng},
        map: this.map,
        icon: {
          url: '/wp-content/themes/class/dist/images/map-marker.png',
          size: new google.maps.Size(160, 184),
          scaledSize: new google.maps.Size(80, 92),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(40, 92)
        }
      });
    });
  }
}

export default LocationMap;
